module.exports = __webpack_public_path__ + "static/media/crp-scroll-left.3a61a7c0.png";